// src/utils/suiteSignIn.js — THE SCREEN'S HALF OF ONE SIGN-IN ACROSS THE SUITE.
// ---------------------------------------------------------------------------
// 2026-09-29. Brett: "inspec suite was meant to be one login and have access
// to all your registered software" — "i would think they could sign in on any
// piece of software." The same file in every app (copy it whole); the server
// half is api/shared/suiteSignIn.js.
//
//   • Not signed in here: ask Synerflo ID once (/api/sso/start). Signed in
//     anywhere in the suite → back signed in. Nobody signed in → back with
//     ?signin=1 and this app's own sign-in screen shows.
//   • Signed in on this app's own screen: pass the browser once through the
//     adoptUrl the sign-in returned, so the other apps open signed in.
//
// NEVER A LOOP: the question is asked at most once a minute per tab, and never
// when the browser has just come back with ?signin=1.

const TRIED_KEY = 'suite_sso_tried';
const QUIET_MS = 60 * 1000;

const store = () => { try { return window.sessionStorage; } catch (_) { return null; } };

/** Where the browser is, without the ?signin=1 marker. */
export function currentPath(loc = window.location) {
  const u = new URL(loc.href);
  u.searchParams.delete('signin');
  return `${u.pathname}${u.search}${u.hash}`;
}

/**
 * Did the browser just come back from Synerflo ID with nobody signed in? The
 * marker is taken off the address (so a reload or a bookmark is clean) and the
 * answer is remembered for this tab's quiet minute.
 */
export function cameBackToSignIn(loc = window.location, hist = window.history) {
  const u = new URL(loc.href);
  if (u.searchParams.get('signin') !== '1') return false;
  try { hist.replaceState(hist.state, '', currentPath(loc)); } catch (_) { /* the address keeps it; harmless */ }
  try { store() && store().setItem(TRIED_KEY, String(Date.now())); } catch (_) { /* no storage: the marker alone guards */ }
  return true;
}

/** Ask Synerflo ID? Not if it was asked in this tab in the last minute. */
export function shouldAskSuite(now = Date.now()) {
  try {
    const t = Number(store() && store().getItem(TRIED_KEY));
    return !(t > 0 && now - t < QUIET_MS);
  } catch (_) { return true; }
}

/** Signed out on purpose: this tab does not ask Synerflo ID straight back. */
export function rememberAsked(now = Date.now()) {
  try { store() && store().setItem(TRIED_KEY, String(now)); } catch (_) { /* ignore */ }
}

/** Send the browser to Synerflo ID — it comes straight back to where it is now. */
export function askSuite(loc = window.location) {
  try { store() && store().setItem(TRIED_KEY, String(Date.now())); } catch (_) { /* ignore */ }
  loc.assign(`/api/sso/start?return=${encodeURIComponent(currentPath(loc))}`);
}

/**
 * After a sign-in on this app's own screen: hand it to Synerflo ID. True when
 * the browser is on its way (the page is about to be replaced); false when
 * there was nothing to hand over — carry on signed in here.
 */
export function handOver(adoptUrl, loc = window.location) {
  if (typeof adoptUrl !== 'string' || !/^https:\/\/[^/]+\/api\/sso\/adopt\?/.test(adoptUrl)) return false;
  loc.assign(adoptUrl);
  return true;
}
